import { adjustMasthead } from "./components/header/masthead.js";
import { headerHeight } from "./components/header/headerHeight.js";
import {resize} from "./components/header/resize.js";


document.addEventListener('DOMContentLoaded', function() {

    headerHeight();


    window.addEventListener('resize', headerHeight);

    if(document.querySelector('.site-masthead')){
        if(document.querySelector('.page-template-page-fyc')){
        
        } else {
            adjustMasthead();

            window.addEventListener('resize', adjustMasthead);
        }

    }
});